<template>
  <div class="m-search">
    <search-bar></search-bar>
    <div class="search-hot">
      <h2 class="title">大家都在搜</h2>
      <div class="list">
        <span class="hotword-item"  v-for="k in hot_keyword" :key="k" @click="this.$router.push({'name': 'searchResult', params: {keyWord: k.KeyWord}})">{{k.KeyWord}}</span>

      </div>
    </div>
    <div class="search-history">
      <h2 class="title">历史搜索</h2>
      <ul  class="history-list">
        <li v-for="history in search_history" :key="history" @click="this.$router.push({'name': 'searchResult', params: {keyWord: history.KeyWord}})"><i class="iconfont History"></i> <a>{{history.KeyWord}}</a></li>
      </ul>
      <div class="clear-history"><a >清除历史记录</a></div>
    </div>
  </div>
</template>

<script>
import searchBar from "@/views/search/searchBar";
import {useModalStore} from "@/store/pinia";

const HISTORY_LIMIT = 6
const HOT_KEYWORDS_EXPIRE = 24 * 60 * 60 * 1000;

export default {
  name: "searchPage",
  components:{
    searchBar
  },
  data(){
    return {
      search_history:null,
      hot_keyword:null,
      modalStore:useModalStore(),
    }
  },
  async mounted() {
    await this.searchLogs();
    await this.hotKeyWord();
  },
  methods:{
    async searchLogs() {
      this.search_history = this.modalStore.searchHistory
      if (this.search_history.length > 0 ){
        return
      }
      try {
        const res = await this.$v_http.get(`/searchHistory`);
        if (res.data?.code === 0) {
          this.search_history = res.data?.data.slice(0, HISTORY_LIMIT);
          this.modalStore.setSearchHistory(this.search_history)
        } else if(res.data?.code==-101){
          console.error("未登录：");
          return
        } else if (res.data?.code==-404){
          console.error("获取视频列表失败：");
          return
        }
        else if (res.data?.code==-500){
          console.error("服务器错误：");
          return
        }
      } catch (error) {
        console.error('Error fetching upper info:', error);
      }
    },
    async hotKeyWord() {
     this.hot_keyword = this.modalStore.hotKeywords
      const hotKeywordTimestamp = this.modalStore.hotKeywordTimestamp;
      if (this.hot_keyword .length > 0 && (hotKeywordTimestamp+HOT_KEYWORDS_EXPIRE)>Date.now()){
        return
      }

      try {
        const res = await this.$v_http.get(`/hotKeyWords`);
        if (res.data?.code === 0) {
          this.hot_keyword = res.data?.data;
          this.modalStore.setHotKeywords(this.hot_keyword);
        }
        else if (res.data?.code==-500){
          console.error("服务器错误：");
          return
        }
      } catch (error) {
        console.error('Error fetching upper info:', error);
      }
    },
  }
}
</script>

<style scoped lang="scss">
.m-search{
  height: 100%;
}
.title{
  color: #999;
  font-size: 3.73333vmin;
  font-weight: 400;
}
.search-hot{
  margin-top: 3.73333vmin;
  margin-bottom: 6.66667vmin;
  padding: 11.73333vmin 3.2vmin 0;
  .list{
    height: 26vmin;
    overflow: hidden;
    .hotword-item{
      display: inline-block;
      font-size: 3.46667vmin;
      height: 9.06667vmin;
      line-height: 8.8vmin;
      padding: 0 3.2vmin;
      color: #505050;
      border: 1px solid #ccc;
      border-radius: 4.53333vmin;
      margin-right: 2.66667vmin;
      margin-top: 3.2vmin;
    }
  }
  h2{
    padding: 0;
    margin: 0;
  }
}
.search-history{
  padding: 0 3.2vmin 0;
  border-top: 2.66667vmin solid #f4f4f4;
  font-size: 0;
  .history-list{
    li{
      height: 11.73333vmin;
      line-height: 11.73333vmin;
      border-bottom: 1px solid #ccc;
      .History{
        color: #999;
        margin-right: 2.13333vmin;
        vertical-align: middle;
        font-size: 4.26667vmin;
      }
      a{
        color: #505050;
        font-size: 3.73333vmin;
        vertical-align: middle;
      }
    }
  }
  .clear-history{
    height: 12.26667vmin;
    line-height: 12.26667vmin;
    text-align: center;
    a{
      font-size: 3.73333vmin;
      color: #999;
    }
  }
}
</style>
